import React, {useState} from 'react'
import {
    BrowserRouter as Router,
    Switch,
    Route
} from "react-router-dom"
import LoadingOverlay from 'react-loading-overlay'
import {Provider as AlertProvider} from 'react-alert'
import AlertTemplate from 'react-alert-template-basic'

import AppContext from "./AppContext"
import PersonDataForm from "./scenes/apply/PersonDataForm"
import ScrollToTop from "./components/ScrollToTop"
import MembershipForm from "./scenes/apply/MembershipForm"
import PremiumThankYouPage from "./scenes/apply/ThankYouPagePremium"
import BasicThankYouPage from "./scenes/apply/ThankYouPageBasic"
import BasicMembershipForm from './scenes/apply/BasicMembershipForm'
import TermsOfUse from "./scenes/TermOfUse"
import PaymentDetailsForm from "./scenes/apply/PaymentDetailsForm"
import Privacy from "./scenes/Privacy";
import Pass from "./scenes/Pass";

export default function App() {

    const [loading, setLoading] = useState(false);

    return (
        <AlertProvider template={AlertTemplate} timeout={5000}>
            <AppContext.Provider value={setLoading}>
                <LoadingOverlay active={loading} spinner>
                    <Router>
                        <ScrollToTop/>
                        <Switch>
                            <Route path="/apply/membership/premium/thank-you">
                                <PremiumThankYouPage/>
                            </Route>
                            <Route path="/apply/membership/basic/thank-you">
                                <BasicThankYouPage/>
                            </Route>
                            <Route path="/apply/membership/basic/:id">
                                <BasicMembershipForm/>
                            </Route>
                            <Route path="/apply/membership/:id">
                                <MembershipForm/>
                            </Route>
                            <Route path="/payment/:id">
                                <PaymentDetailsForm/>
                            </Route>
                            <Route path="/apply/:key?">
                                <PersonDataForm/>
                            </Route>
                            <Route path="/terms">
                                <TermsOfUse/>
                            </Route>
                            <Route path="/privacy">
                                <Privacy/>
                            </Route>
                            <Route path="/pass/:id">
                                <Pass/>
                            </Route>
                            <Route path="/index.html">
                                <PersonDataForm/>
                            </Route>
                            <Route path="/">
                                <PersonDataForm/>
                            </Route>
                        </Switch>
                    </Router>
                </LoadingOverlay>
            </AppContext.Provider>
        </AlertProvider>
    )
}